<template>
	<div class="center_content center_layout">
		<b-container class="bv-example-row">
			<div v-if="type!=2" class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>使用说明</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div :style="type!=2?'padding: 20px;':''" class="list_area">
				<div class="content_box">
					<div style="margin: 0 auto;" v-if="informList==undefined||informList.length==0">
						<el-empty description="暂无数据"></el-empty>
					</div>
					<div v-else style="width: 100%;" v-for="(item,index) in informList" :key="index">
						<inform class="card_item" :item="item"></inform>
					</div>
				</div>
				<div v-if="totalElements>0" style="text-align: center;margin-top: 15px;">
					<el-pagination background @current-change="getList" :current-page.sync="form.pageNum"
						:page-size="form.pageSize" layout="total, prev, pager, next" :total="totalElements">
					</el-pagination>
				</div>
			</div>
		</b-container>
	</div>
</template>

<script>
	import {
		noticeList
	} from "@/api/lesson";
	import inform from './inform.vue'
	export default {
		components: {
			inform
		},
		data() {
			return {
				loading: false,
				totalElements: 0,
				form: {
					noticeTitle: '',
					pageSize: 10,
					pageNum: 1,
					noticeType:2
				},
				informList: []
			}
		},
		mounted() {
			this.getList()
		},
		props: ['type'],
		methods: {
			getList() {
				this.loading = true
				//获取通知
				noticeList(this.form).then(
					(response) => {
						this.informList = response.rows;
						this.totalElements = response.total
						this.loading = false
					}
				);
			},
			searchList() {
				this.form.pageNum = 1
				this.form.pageSize = 10
				this.getList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.breadcrumb {
		margin: 20px 0;
		background-color: #fff;
	}

	.center_content {
		.list_area {
			// border: 1px solid #EEEEEE;
			background-color: #ffffff;

			.top_area {
				.left {
					.name {
						margin-right: 30px;
					}
				}

				.right {
					font-size: 14px;

					.btn {
						margin-right: 30px;
					}
				}
			}

			.content_box {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.card_item {
					border: 1px solid #EDEDED;
					margin-top: 20px;
				}

				.card_item:hover {
					border: 1px solid #1395F3;
					box-shadow: 0px 2px 15px 6px rgba(51, 51, 51, 0.06);
					transition: all .2s ease-in-out;
				}
			}

			.bottom_pagination {
				height: 100px;
				position: relative;

				.pagination {
					position: absolute;
					top: 50%;
					right: 25%;
					transform: translate(-50%, -50%);
				}
			}
		}
	}

	.el-input ::v-deep .el-input__inner {
		border-radius: 24px;
		border: solid 1px #ededed;
		padding-left: 15px;
	}

	.el-icon-search {
		margin-top: 13px;
		margin-right: 10px;
	}
</style>